import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useImmer } from 'use-immer'
import { Table, Datetime, Heading, Button, IconButton } from '../components'
import { normalizr } from '../helpers'
import { http } from '../http'
import { FirmwareCreateRoute } from './FirmwareCreateRoute'

export const FirmwareRouter = () => {
  const [store, setStore] = useImmer({})
  const { data, status } = store

  useEffect(() => {
    if (null == status) {
      http.fetch('/crm.firmware.list').then(res => {
        setStore(draft => {
          if (!res.ok) {
            draft.status = 'rejected'
            return
          }

          draft.status = 'resolved'
          draft.data = normalizr(res.data)
        })
      })
    }
  }, [status, setStore])

  if (null == status || status === 'pending') {
    return 'Loading...'
  } else if ('rejected' === status) {
    return 'Failed to load resource.'
  }

  return (
    <>
      <Heading
        text="Firmwares"
        button={
          <Button.Link label="Add" to="new"/>
        }
      />
      <Table.Container empty={0 === data.ids.length}>
        <colgroup>
          <col style={{ width: 240 }}/>
          <col style={{ width: 120 }}/>
          <col/>
        </colgroup>
        <Table.Head>
          <tr>
            <th>Created at</th>
            <th>Version</th>
            <th/>
          </tr>
        </Table.Head>
        <Table.Body>
          {data.ids.map(id => {
            const cur = data.byId[id]

            return (
              <tr key={cur.id}>
                <td>
                  <Datetime value={cur.createdAt}/>
                </td>
                <td>{cur.version}</td>
                <td className="text-end">
                  <IconButton
                    icon="bin"
                    color="danger"
                    onClick={() => {
                      if (!window.confirm('Are you sure?')) {
                        return
                      }

                      setStore(draft => { draft.status = 'pending' })
                      http.fetch('/crm.firmware.delete', { id: cur.id }).then(() => {
                        setStore(draft => { delete draft.status })
                      })
                    }}
                  />
                </td>
              </tr>
            )
          })}
        </Table.Body>
      </Table.Container>
      <Routes>
        <Route path="new" element={<FirmwareCreateRoute onCommit={() => setStore(draft => { delete draft.status })}/>}/>
      </Routes>
    </>
  )
}